// extracted by mini-css-extract-plugin
export var columnItem = "_bx-3";
export var columnItemDraggable = "_bx-4";
export var dragHandle = "_bx-0";
export var dragHandleHovered = "_bx-1";
export var dropdown = "_bx-5";
export var dropdownContent = "_bx-7";
export var dropdownInner = "_bx-6";
export var filterDropdownHeader = "_bx-8";
export var icon = "_bx-2";
export var sectionDivider = "_bx-9";